import React, { useRef, useState } from "react";
import { API } from "@/lib/api";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/utils";
import { toast } from "sonner";
import { Upload, CheckCircle2, FileCheck2 } from "lucide-react";

export default function ProofUpload({ booking, onUploaded }) {
  const { t } = useApp();
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const proof = booking.payment_proof;
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file); setBusy(true);
    try { await api.post(`/public/booking/${booking.code}/proof`, fd); toast.success(t("proof_uploaded")); onUploaded(); }
    catch (e) { toast.error(e?.response?.data?.detail || t("failed")); }
    finally { setBusy(false); }
  };
  if (booking.payment_status !== "unpaid" && !proof) return null;
  return (
    <div className="mt-6 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm print:hidden" data-testid="proof-section">
      <div className="text-xs uppercase text-emerald-800 font-semibold mb-2">{t("proof_title")}</div>
      {proof ? (
        <div className="flex flex-wrap items-center gap-3">
          {proof.status === "verified" ? <CheckCircle2 className="w-5 h-5 text-emerald-600" /> : <FileCheck2 className="w-5 h-5 text-amber-600" />}
          <div><div className="font-semibold" data-testid="proof-status">{proof.status === "verified" ? t("proof_verified") : t("proof_waiting")}</div>
            <div className="text-slate-600">{proof.original_filename} · {formatDate(proof.uploaded_at)}</div></div>
          <a className="text-emerald-700 underline" href={`${API}/public/booking/${booking.code}/proof`} target="_blank" rel="noreferrer" data-testid="proof-view">{t("view")}</a>
          {proof.status !== "verified" && <Button size="sm" variant="outline" disabled={busy} onClick={() => ref.current.click()} data-testid="proof-reupload">{t("reupload")}</Button>}
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-3">
          <p className="text-slate-700 flex-1">{t("proof_desc")}</p>
          <Button disabled={busy} onClick={() => ref.current.click()} className="bg-emerald-600 hover:bg-emerald-700" data-testid="proof-upload-btn"><Upload className="w-4 h-4 mr-2" />{busy ? "..." : t("upload_proof")}</Button>
        </div>
      )}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="proof-file-input" />
    </div>
  );
}
